module.exports = __webpack_public_path__ + "img/captureerror.d55a08f2.svg";